var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.$tr('learnOnlyDeviceLabel'))+"\n  ")]),_c('div',{staticClass:"notice"},[_vm._v("\n    "+_vm._s(_vm.$tr('learnOnlyDeviceNotice'))+"\n  ")])])}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }